/**
 * Bridge so non-React code (e.g. design-tool) can set pageHasUnsavedChanges.
 * AppState registers its setter on mount; call setPageHasUnsavedChangesGlobal to update.
 */
let setter: ((value: boolean) => void) | null = null;

export function registerUnsavedChangesBridge(fn: (value: boolean) => void): () => void {
  setter = fn;
  return () => {
    setter = null;
  };
}

export function setPageHasUnsavedChangesGlobal(value: boolean): void {
  setter?.(value);
}
